// @flow
'use strict';

import { connect } from 'react-redux';

import ListaNfse from './lista';

export default connect<*, *, *, *, *, *>()(ListaNfse);
